/**
 * Initialise Slick sliders
 */
$(document).ready(function() {

	// Main product image
	$('.product-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-caret-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-caret-right"></i></button>',
		dots: false,
		swipe: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					dots: true,
					arrows: false,
					swipe: true
				}
			}
		]
	});

	// Nav thumbnails for main product image
	$('.product-slider-nav').slick({
		slidesToShow: 8,
		slidesToScroll: 1,
		asNavFor: '.product-slider',
		swipe: false,
		focusOnSelect: true,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-caret-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-caret-right"></i></button>'
	});

	/**
	 * This block manually recreates broken `asNavFor` on `.product-slider`
	 * See: https://stackoverflow.com/questions/31382661/slick-slider-sync-situation
	 */
	$('.product-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
	  var inFocus = $('.product-slider .slick-current').attr('data-slick-index');
	  $('.product-slider-nav .slick-current').removeClass('slick-current');
	  $('.product-slider-nav .slick-slide[data-slick-index="' + inFocus + '"]').trigger('click');
	});

	// Compatible products on single product page
	$('.compatible-products-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-caret-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-caret-right"></i></button>',
		dots: false,
		swipe: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					swipe: true,
					arrows: false,
					dots: true
				}
			}
		]
	});

	// Similar products on single product page
	$('.similar-products-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-caret-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-caret-right"></i></button>',
		dots: false,
		swipe: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					swipe: true,
					arrows: false,
					dots: true
				}
			}
		]
	});

	// Slider for product categories in product archives
	$('.product-category-nav-slider').slick({
		slidesToShow: 6,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-caret-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-caret-right"></i></button>',
		swipe: false,
		responsive: [
			{
				breakpoint: 1260,
				settings: {
					slidesToShow: 5
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint: 768,
				settings: 'unslick'
			}
		]
	});

});